<template>
  <div class="flex flex-col pl-8 pr-3 w-full h-full">
    <div class="flex flex-row items-center gap-3 mb-3">
      <button
        @click="setActiveSubMenu('Tool')"
        class="flex flex-row justify-center items-center w-4 h-4 bg-gray-400 rounded-md"
        title="Kembali ke menu tool">
        <i class="material-icons text-lg text-white">chevron_left</i>
      </button>
      <h1 class="flex flex-col">
        <span class="text-sm text-white mr-1 font-bold">Tampilan zona</span>
        <i class="text-xs text-white">(daftar zona yang telah ditambahkan, centang untuk menampilkan zona pada map)</i>
      </h1>
    </div>
    <div class="Scroll pr-3 pb-3 w-full h-full overflow-hidden">
      <ul class="mb-3">
        <li
          v-for="(zone, index) in zones.data"
          :key="index"
          class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
          <input
            @change="changeZone(index, $event)"
            :checked="listZone[zone.id]?.enable"
            type="checkbox">
          <span class="text-xs text-slate-300">{{ zone.title }}</span>
        </li>
      </ul>
      <Pagination
        class="justify-end items-end"
        :offset="zones.offset"
        :limit="zones.limit"
        :total="zones.total"
        :handler="changePage" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from './Pagination.vue'

export default {
  name: 'ToolZoneShow',
  computed: {
    ...mapGetters([
      'zones',
      'listZone'
    ])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions([
      'toLoadZones',
      'toToggleZone'
    ]),
    ...mapMutations(['setActiveSubMenu']),
    changeZone: async function (index, $event) {
      await this.toToggleZone({
        index,
        enable: $event.target.checked
      })
    },
    changePage: async function (page) {
      await this.toLoadZones({
        offset: page.offset,
        limit: page.limit
      })
    }
  },
  mounted: async function () {
    await this.toLoadZones()
  }
}
</script>
